import { CustomIconsProps } from './types';

export function MonitoramentoIcon({
  size = 24,
  color = 'currentColor',
}: CustomIconsProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 13H5V18H3V13ZM7 10H9V18H7V10ZM11 7H13V18H11V7ZM15 4H17V18H15V4ZM19 8H21V18H19V8ZM2 20H22V22H2V20Z"
        fill={color}
      />
    </svg>
  );
}
